import z from 'zod';

import { WorkoutPlanId } from '../../../BrandedIds';
import { zodBrandedUuid } from '../../../utils/Zod';
import { BaseLoanEvent } from '../../BaseLoanEvent';

export const CompleteForbearanceWorkoutPlanEvent = BaseLoanEvent.extend({
  type: z.literal('completeForbearanceWorkoutPlan'),
  workoutPlanId: zodBrandedUuid<WorkoutPlanId>(),
});
export type CompleteForbearanceWorkoutPlanEvent = z.infer<typeof CompleteForbearanceWorkoutPlanEvent>;
